import type { MainMenuConfig } from './layout/main-menu-config.type';
import type { AdminUserRole } from '../backend/main';

function addPrefix(item: string): string {
  return `MENU.${item}`;
}

export const MAIN_MENU_CONFIG: MainMenuConfig<AdminUserRole> = {
  items: [
    {
      label: addPrefix('ADMIN_USER'),
      routeLink: '/admin-users',
      icon: 'pct-mdi-account-multiple',
      role: ['SystemAdmin'],
      name: 'admin-user',
    },
    {
      label: addPrefix('USERS'),
      routeLink: '/users',
      icon: 'pct-mdi-account-multiple',
      role: ['SystemAdmin', 'Admin'],
      name: 'users',
    },
    {
      label: addPrefix('NEWS'),
      routeLink: '/news',
      icon: 'pct-mdi-newspaper',
      role: ['SystemAdmin', 'Admin'],
      name: 'news',
    },
    {
      label: addPrefix('EVENT'),
      routeLink: '/events',
      icon: 'pct-mdi-calendar',
      role: ['SystemAdmin', 'Admin'],
      name: 'event',
    },
    {
      label: addPrefix('OFFER'),
      routeLink: '/offers',
      icon: 'pct-mdi-sale',
      role: ['SystemAdmin', 'Admin'],
      name: 'offer',
    },
    {
      label: addPrefix('LOCATION'),
      routeLink: '/locations',
      icon: 'pct-mdi-map',
      role: ['SystemAdmin', 'Admin'],
      name: 'location',
    },
    {
      label: addPrefix('POI'),
      routeLink: '/pois',
      icon: 'pct-mdi-map-marker-multiple',
      role: ['SystemAdmin', 'Admin'],
      name: 'poi',
    },
    {
      label: addPrefix('NOTIFICATIONS'),
      routeLink: '/notifications',
      icon: 'pct-mdi-bell',
      role: ['SystemAdmin', 'Admin'],
      name: 'notifications',
    },
    {
      label: addPrefix('TOUR'),
      routeLink: '/tours',
      icon: 'pct-mdi-map-marker-distance',
      role: ['SystemAdmin', 'Admin'],
      name: 'tour',
    },
    {
      label: addPrefix('ONBOARDING_STEP'),
      routeLink: '/onboarding-steps',
      icon: 'pct-mdi-cellphone-information',
      role: ['SystemAdmin', 'Admin'],
      name: 'onboarding-step',
    },
  ],
};
